/**
 * Selector matching no documents — keeps a query inert without skipping it.
 * Matches an impossible primary key rather than `{ $exists: false }` so RxDB
 * short-circuits on the primary index instead of scanning the collection.
 */
export const MATCH_NOTHING = { id: { $eq: "__rbac_no_access__" } };
